<template>
  <div id="table-outer-container">

    <header>
      <h2>{{ strings.workspacesListHeading }}</h2>
      <home-nav/>
    </header>

    <home-table v-if="canTableBeShown" :status="moreAvailable" :action="updateWorkspaces" />

    <spinner v-else-if="isLoading" />

    <template v-else>
      <div id="no-workspaces">
        <h1>{{ strings.noWorkspaces }}</h1>
        <p class="error-message">{{ errors.workspaceErr }}</p>
      </div>
    </template>

  </div>
</template>

<script>
import { URLS } from '@/utils/urls'
import { Formatters } from '@/utils/formatters'

import navigation from '@/utils/navigation'
import { mapActions, mapGetters } from 'vuex'

import PageButton from '@/components/common/Page-Button'
import HomeNav from '@/components/home/HomeNav'
import HomeTable from '@/components/home/HomeTable'
import Spinner from '@/components/common/Spinner'


export default {
  data () {
    return {
      strings: {
        workspacesListHeading: this.translate('workspaces list heading'),
        loadMoreWorkspaces: this.translate('load more workspaces'),
        tableColumnName: this.translate('table column name'),
        tableColumnCreator: this.translate('table column creator'),
        tableColumnModified: this.translate('table column modified'),
        tableColumnCreated: this.translate('table column created'),
        tableColumnAccessed: this.translate('table column accessed'),
        accessFullAccess: this.translate('access fullaccess'),
        accessReadOnly: this.translate('access readonly'),
        accessLocked: this.translate('access locked'),
        noWorkspaces: this.translate('no workspaces to display')
      },
      moreAvailable: true,
      errors: {
        workspaceErr: ''
      }
    }
  },
  components: {
    'page-button': PageButton,
    'spinner': Spinner,
    'home-nav': HomeNav,
    'home-table': HomeTable
  },
  computed: {
    ...mapGetters({
      userId: 'user/userId',
      allWorkspaces: 'workspaces/allWorkspaces',
      isLoading: 'workspaces/isLoading'
    }),
    canTableBeShown () {
      return this.errors.workspaceErr === '' &&
        (this.allWorkspaces && this.allWorkspaces.length > 0)
    }
  },
  methods: {
    ...mapActions({
      getAllWorkspaces: 'workspaces/getAllWorkspaces'
    }),
    flashRow (id) {
      // Get Element
      const row = document.querySelector(`#table-content tr[data-workspace-id='${id}']`)
      if (row) {
        // Add Class
        row.classList.add('highlight')
        // Scroll To
        row.scrollIntoView({ behavior: 'smooth', block: 'start' })
        // Force Added Class to be Evaluated
        void row.offsetWidth
        // Remove Class
        row.classList.remove('highlight')
      }
    },
    async updateWorkspaces (options = { initialLoad: false }) {
      // Get Last ID from Store
      const workspaceList = this.allWorkspaces || []
      const count = workspaceList.length
      const last = workspaceList[count-1] || {}
      const id = last.Id
      // Fetch More Rows
      try {
        const res = await this.getAllWorkspaces({ userId: this.userId, initialLoad: options.initialLoad })
        setTimeout(() => {
          this.moreAvailable = !res.areAllWorkspacesLoaded
        }, 0)
        // Flash Last Row and Scroll to New Rows
        if (options.initialLoad === false && id !== undefined) this.flashRow(id)
      } catch (err) {
        console.error(err)
        this.errors.workspaceErr = err[0]
      }
    },
    translate (string, object) {
      return this.$i18n.translate(string, object)
    }
  },
  mounted () {
    this.updateWorkspaces({ initialLoad: true })
  }
}
</script>

<style lang="scss">
@import "@/styles/components/_home.scss";
</style>
